import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import yellowWebImage from "../../assets/images/bg-login-ui.png";
import haryanaGovticon from "../../assets/icons/Emblem_of_Haryana.svg.png";
import AuthForm from "./AuthForm";

const ADMIN_TABS = [{ key: "admin", label: "Admin" }];
const MCC_TABS = [{ key: "mcc", label: "MCC" }];
const USER_TABS = [
  { key: "trainee", label: "Trainee" },
  { key: "trainer", label: "Trainer" },
  { key: "iti", label: "ITI" },
];

const LoginLayout = () => {
  // const { i18n } = useTranslation();
  const location = useLocation();

  const initialPath =
    typeof window !== "undefined" ? window.location.pathname : "";
  const isInitialAdmin = initialPath === "/admin";
  const isInitialMcc = initialPath === "/mcc";

  const [activeTab, setActiveTab] = useState(
    isInitialAdmin ? "admin" : isInitialMcc ? "mcc" : "trainee"
  );
  const [portalMode, setPortalMode] = useState(
    isInitialAdmin ? "admin" : isInitialMcc ? "mcc" : "user"
  );
  const [previousTab, setPreviousTab] = useState(null);
  const [direction, setDirection] = useState("right");
  const [isAnimating, setIsAnimating] = useState(false);

  const currentTabs =
    portalMode === "admin"
      ? ADMIN_TABS
      : portalMode === "mcc"
        ? MCC_TABS
        : USER_TABS;
  const tabRefs = useRef([]);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/admin") {
      setPortalMode("admin");
      setActiveTab("admin");
    } else if (path === "/mcc") {
      setPortalMode("mcc");
      setActiveTab("mcc");
    } else {
      setPortalMode("user");
      setActiveTab((t) => (t === "admin" || t === "mcc" ? "trainee" : t));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (previousTab !== null && previousTab !== activeTab) {
      const currentIndex = currentTabs.findIndex(
        (tab) => tab.key === activeTab
      );
      const previousIndex = currentTabs.findIndex(
        (tab) => tab.key === previousTab
      );
      setDirection(currentIndex > previousIndex ? "left" : "right");
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 500);
      return () => clearTimeout(timer);
    }
    setPreviousTab(activeTab);
  }, [activeTab, currentTabs]);

  const handleTabChange = (tabKey) => {
    if (!isAnimating && activeTab !== tabKey) {
      setActiveTab(tabKey);
    }
  };

  const PillTabBar = () => (
    <div className="flex bg-gray-100 rounded-full p-1 mb-5 w-full max-w-xs h-11">
      {currentTabs.map((tab, idx) => (
        <button
          key={tab.key}
          ref={(el) => (tabRefs.current[idx] = el)}
          onClick={() => handleTabChange(tab.key)}
          disabled={isAnimating}
          className={`flex-1 flex items-center justify-center
            h-full rounded-full text-sm font-semibold transition-all
            ${
              activeTab === tab.key
                ? "bg-[#0e766c] text-white shadow"
                : "text-gray-600 hover:bg-gray-200"
            }
            ${isAnimating ? "cursor-default" : "cursor-pointer"}`}
        >
          {tab.label.toUpperCase()}
        </button>
      ))}
    </div>
  );

  const renderAnimatedForm = () => {
    const animationClass = isAnimating
      ? direction === "left"
        ? "animate-slide-in-left "
        : "animate-slide-in-right"
      : "";

    return (
      <div className="relative overflow-hidden">
        <div key={activeTab} className={`w-full h-full ${animationClass}`}>
          <AuthForm type={activeTab} />
        </div>
      </div>
    );
  };

  return (
    <section
      className="relative min-h-screen w-full flex items-center justify-center bg-cover bg-center px-3 sm:px-6"
      style={{
        backgroundImage: `url(${yellowWebImage})`,
        backgroundPosition: "15% 10%",
      }}
    >
      <style>{`
        @keyframes slideInLeft {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideInRight {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
        .animate-slide-in-left {
          animation: slideInLeft 0.5s ease-in-out forwards;
        }
        .animate-slide-in-right {
          animation: slideInRight 1s ease-in-out forwards;
        }
      `}</style>

      <div className="absolute inset-0 bg-gray-200/50" />

      <div className="relative bg-white rounded-2xl sm:rounded-3xl flex flex-col md:flex-row w-full max-w-[95%] sm:max-w-[90%] md:max-w-[900px] lg:max-w-[1040px] min-h-[500px] sm:min-h-[550px] md:min-h-[520px] overflow-hidden shadow-lg sm:shadow-xl">
        {/* LEFT IMAGE */}
        <div className="hidden md:flex md:w-[55%] lg:w-[58%] items-center justify-center p-4 md:p-5 lg:p-6">
          <div className="w-full h-full rounded-2xl overflow-hidden">
            <img
              src={yellowWebImage}
              alt="Decorative"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="w-full md:w-[45%] flex flex-col items-center justify-center px-4 sm:px-8 md:px-10 py-6 pb-8">
          {/* Logo */}
          <img
            src={haryanaGovticon}
            alt="Haryana Govt"
            className="w-24 mb-6"
          />

          <h2 className="text-base sm:text-lg md:text-xl font-semibold text-green-800 mb-4 text-center">
            Dual System of Training (DST)
          </h2>

          {/* Tabs OR portal title */}
          {portalMode === "user" ? (
            <PillTabBar />
          ) : (
            <h3 className="text-lg font-semibold text-gray-700 mb-6">
              {portalMode === "admin" ? "Admin Login" : "MCC Login"}
            </h3>
          )}

          {/* FORM */}
          <div className="w-full max-w-xs">
            {renderAnimatedForm()}
          </div>

          {/* Language switch */}
          {/* <div className="mt-6 text-xs sm:text-sm text-right w-full">
            <span
              className={`cursor-pointer ${
                i18n.language === "en"
                  ? "text-[#0e766c] font-medium"
                  : "text-gray-500"
              }`}
              onClick={() => i18n.changeLanguage("en")}
            >
              English
            </span>
            <span className="mx-2">|</span>
            <span
              className={`cursor-pointer ${
                i18n.language === "hi"
                  ? "text-[#0e766c] font-medium"
                  : "text-gray-500"
              }`}
              onClick={() => i18n.changeLanguage("hi")}
            >
              हिंदी
            </span>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default LoginLayout;